import React from "react";

const Checkboxcomponent = React.forwardRef(
  ({ index, ind, val, form, setForm, getFormdata }, ref) => {
    const handleChange = (e) => {
      form[index].options[ind].form.value = e.target.checked;
      setForm([...form]);
      if (getFormdata) getFormdata();
    };

    return (
      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={val?.form?.value || false}
          onChange={handleChange}
          ref={ref[val?.form?.name?.concat(index + "" + ind)]}
          id={val?.form?.name}
        />
        <label htmlFor={val?.form?.name}>{val?.name}</label>
      </div>
    );
  }
);

export default Checkboxcomponent;
